export enum ExternalSystemSyncLogSeverity {
Info,
Warning,
Error,
}
